import {Typography} from "antd";
import ResultBodyCell from "../../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../../components/table/ResultHeaderCell";
import WinFormInput from "../WinFormInput";
import {useEffect} from "react";
import UIComponentHelper from "../UIComponentHelper";

export default function DeckRoadwayEditor({data, windowName, targetWindow, title}) {

    useEffect(() => {
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'distance'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'width'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'weir_coef'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'us_embankment_ss'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'ds_embankment_ss'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'max_submergence'})
        UIComponentHelper.setStyleForInput({targetWindow, windowName, name: 'min_weir_flow_el'})
        UIComponentHelper.setStyleForRadio({targetWindow, windowName, name: 'weir_crest_shape'})
        UIComponentHelper.setStyleForTable({targetWindow, windowName, name: 'station_table', skipIndex: [0]})
    }, [data])

    return (
        <div style={{}}>
            <Typography.Text style={{fontSize: '11pt', fontWeight: 'bold', backgroundColor: 'white', width: '100%', marginLeft: 4}}>
                Deck/Roadway Data Editor - {title}
            </Typography.Text>
            <div style={{width: 480, backgroundColor: '#f5f5f5', fontSize: '9pt', padding: 2, paddingLeft: 4, paddingRight: 4, border: '1px solid #cfcfcf'}} id={windowName}>
                <table style={{width: '100%'}}>
                    <tr>
                        <td>
                            <div style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Distance</div>
                        </td>
                        <td>
                            <div style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Width</div>
                        </td>
                        <td>
                            <div style={{textAlign: 'center', backgroundColor: '#008080', color: 'white'}}>Weir Coef</div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{width: '33.3%'}}>
                            <WinFormInput id={`${windowName}-distance`} style={{width: '100%'}}>
                                {data?.distance}
                            </WinFormInput>
                        </td>
                        <td style={{width: '33.3%'}}>
                            <WinFormInput id={`${windowName}-width`} style={{width: '100%'}}>
                                {data?.width}
                            </WinFormInput>
                        </td>
                        <td style={{width: '33.3%'}}>
                            <WinFormInput id={`${windowName}-weir_coef`} style={{width: '100%'}}>
                                {data?.weir_coef}
                            </WinFormInput>
                        </td>
                    </tr>
                </table>
                <table style={{width: '100%', marginTop: 8}}>
                    <thead style={{tableLayout: 'fixed', width: '100%', display: 'block'}}>
                        <tr style={{backgroundColor: '#008080', color: 'white',  textAlign: 'center'}}>
                            <td colSpan={4}>Upstream</td>
                            <td colSpan={3}>Downstream</td>
                        </tr>
                        <tr>
                            <ResultHeaderCell style={{width: 30}}></ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>High Chord</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Low Chord</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>High Chord</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'center', width: 70,}}>Low Chord</ResultHeaderCell>
                        </tr>
                    </thead>
                    <div style={{overflow: 'auto'}}>
                        <tbody id={`${windowName}-station_table`} style={{height: 250, tableLayout: 'fixed', width: '100%', display: 'block'}}>
                        {
                            UIComponentHelper.getTableData({table1: data?.station_table_us, table2: data?.station_table_ds}).map((x,idx) => (
                                <tr>
                                    <ResultHeaderCell style={{width: 30}}>{idx+1}</ResultHeaderCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[0]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[1]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[2]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[3]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[4]}</ResultBodyCell>
                                    <ResultBodyCell style={{backgroundColor: 'white', width: 70,}}>{x[5]}</ResultBodyCell>
                                </tr>
                            ))
                        }
                        </tbody>
                    </div>
                </table>
                <div style={{display: 'flex', alignItems: 'center', marginTop: 8, width: '100%', justifyContent: 'space-between'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <label style={{width: 120}}>U.S Embankment SS</label>
                        <WinFormInput id={`${windowName}-us_embankment_ss`}>
                            {data?.us_embankment_ss}
                        </WinFormInput>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <label style={{width: 120}}>D.S Embankment SS</label>
                        <WinFormInput id={`${windowName}-ds_embankment_ss`}>
                            {data?.ds_embankment_ss}
                        </WinFormInput>
                    </div>
                </div>
                <fieldset style={{border: '1px solid #a5a5a5', padding: 4, marginTop: 8}}>
                    <legend style={{fontSize: '9pt', marginLeft: 4, paddingLeft: 2, width: 60}}>Weir Data</legend>
                    <div style={{display: 'flex', alignItems: 'center', marginTop: 8, width: '100%', justifyContent: 'space-between'}}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <label style={{width: 120}}>Max Submergence</label>
                            <WinFormInput id={`${windowName}-max_submergence`}>
                                {data?.max_submergence}
                            </WinFormInput>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <label style={{width: 120}}>Min Weir Flow El:</label>
                            <WinFormInput id={`${windowName}-min_weir_flow_el`}>
                                {data?.min_weir_flow_el}
                            </WinFormInput>
                        </div>
                    </div>
                    <div style={{marginTop: 8}}>
                        <div id={`${windowName}-weir_crest_shape`} style={{textDecoration: 'underline'}}>Weir Crest Shape</div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <input name={`${windowName}-weir_crest_shape-radio`} type={'radio'} readOnly={true} value={'broad_crested'} checked={data?.weir_crest_shape === 0}/>
                            <label style={{marginLeft: 2}}>Broad Crested</label>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <input name={`${windowName}-weir_crest_shape-radio`} type={'radio'} readOnly={true} value={'ogee'} checked={data?.weir_crest_shape === -1}/>
                            <label style={{marginLeft: 2}}>Ogee</label>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    )
}